<template>
  <v-container fluid grid-list-md>
    <v-card class="pa-3 mb-2">
      <v-flex d-flex xs12 sm12 pa-2>
        <h2 class="title">{{ $vuetify.t('$vuetify.AdminQuorum.school') }}</h2>
      </v-flex>
      <v-layout row wrap justify-center align-content-center>
        <v-flex d-flex xs6 pa-2>
          <v-text-field
            v-model='schoolQuorum'/>
        </v-flex>
        <v-flex d-flex xs6 fill-height align-center>
          {{ $vuetify.t('$vuetify.AdminQuorum.schoolPercent') }}
        </v-flex>
      </v-layout>
      <v-flex d-flex xs12 pa-2>
        <h2 class="title">{{ $vuetify.t('$vuetify.AdminQuorum.class') }}</h2>
      </v-flex>

      <v-layout row wrap>
        <v-flex d-flex xs6 pa-2>
          <v-text-field
            v-model='classQuorum'/>
        </v-flex>
        <v-flex d-flex xs6 fill-height align-center>
          {{ $vuetify.t('$vuetify.AdminQuorum.classPercent') }}
        </v-flex>
      </v-layout>

      <v-flex d-flex xs12 pa-2>
        <v-btn
          @click="submit"
          class="save-button">
          {{ $vuetify.t('$vuetify.UserSettings.save') }}
        </v-btn>
      </v-flex>
    </v-card>
  </v-container>
</template>

<script>

import api from '@/api'

export default {
  name: 'Quorum',
  data: function () {
    return {}
  },

  props: {},

  computed: {
    schoolQuorum: {
      get () {
        return (this.$store.getters.schoolConfig.schoolQuorum) ? this.$store.getters.schoolConfig.schoolQuorum : 30
      },
      set (value) {
        this.$store.commit('UPDATE_SCHOOL_CONFIG_KEY', {key: 'schoolQuorum', value: value})
      }
    },
    classQuorum: {
      get () {
        return (this.$store.getters.schoolConfig.classQuorum) ? this.$store.getters.schoolConfig.classQuorum : 30
      },
      set (value) {
        this.$store.commit('UPDATE_SCHOOL_CONFIG_KEY', {key: 'classQuorum', value: value})
      }
    }
  },

  methods: {
    submit: function () {
      api.school.updateConfig(this.$store.getters.selected_school, 'schoolQuorum', this.schoolQuorum)
        .then(() => {
          api.school.updateConfig(this.$store.getters.selected_school, 'classQuorum', this.classQuorum)
        })
    }
  }
}
</script>
